export const convertToPercent = (value: number) => {
  return parseFloat((value * 100).toFixed(2));
};
